// src/components/charts/SexeChart.vue
<template>
  <div class="chart-container">
    <canvas ref="chartCanvas"></canvas>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, onBeforeUnmount } from 'vue'
import { Chart, DoughnutController, ArcElement, Tooltip, Legend, Title } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'

// Enregistrer les composants Chart.js nécessaires
Chart.register(DoughnutController, ArcElement, Tooltip, Legend, Title, ChartDataLabels)

const props = defineProps({
  data: {
    type: Array,
    required: true
  }
})

const chartCanvas = ref(null)
let chart = null

const createChart = () => {
  if (!chartCanvas.value) return
  
  // Préparer les données
  const labels = props.data.map(item => item.sexe === 'M' ? 'Hommes' : 'Femmes')
  const values = props.data.map(item => item.total)
  
  // Calculer les pourcentages pour les afficher
  const total = values.reduce((sum, value) => sum + value, 0)
  const percentages = values.map(value => ((value / total) * 100).toFixed(1) + '%')
  
  // Créer le graphique
  chart = new Chart(chartCanvas.value, {
    type: 'doughnut',
    data: {
      labels,
      datasets: [{
        data: values,
        backgroundColor: ['#42a5f5', '#ec407a']
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'bottom',
          labels: {
            usePointStyle: true,
            padding: 20
          }
        },
        tooltip: {
          callbacks: {
            label: (context) => {
              const value = context.raw
              const percentage = ((value / total) * 100).toFixed(1) + '%'
              return `${context.label}: ${value} (${percentage})`
            }
          }
        },
        datalabels: {
          color: '#fff',
          font: {
            weight: 'bold',
            size: 16
          },
          formatter: (value, context) => {
            return percentages[context.dataIndex]
          },
          textAlign: 'center',
          borderWidth: 2,
          borderColor: '#fff',
          borderRadius: 4,
          padding: 6,
          textStrokeColor: 'rgba(0,0,0,0.3)',
          textStrokeWidth: 1,
          textShadowBlur: 5,
          textShadowColor: 'rgba(0,0,0,0.3)'
        },
        title: {
          display: true,
          text: 'Répartition par sexe',
          font: {
            size: 16
          }
        }
      },
      cutout: '60%'
    }
  })
}

// Réagir aux changements de données
watch(() => props.data, () => {
  if (chart) {
    chart.destroy()
  }
  createChart()
}, { deep: true })

onMounted(() => {
  createChart()
})

onBeforeUnmount(() => {
  if (chart) {
    chart.destroy()
  }
})
</script>

<style scoped>
.chart-container {
  height: 300px;
  position: relative;
}
</style>